/**
 * XLM - Innovation & Technology | João Rodrigues | v2.0 | 2026*
 * 
 * Exportação e comunicação com o backoffice ECLI:
 * - ExportButton: confirmação via modal antes de enviar para publicação
 * - sendBackAnon: envia texto anonimizado via postMessage para a página principal
 * - getUploadUrl: constrói URL de comunicação com base em variáveis de ambiente
 * - Substituição de confirm() síncrono por modal assíncrono useAsyncConfirm
 */

import { AnonimizeStateState } from "../../types/AnonimizeState";
import { EntityTypeI } from "../../types/EntityTypes";
import { UserFile } from "../../types/UserFile";
import { Button } from "../../util/BootstrapIcons";
import { SpecificOffsetRange, useTypesDict } from "../../util/uses";
import { renderBlock } from "./render";
import { useAsyncConfirm } from "../../util/useAsyncConfirm";



export function ExportButton({ file }: { file: UserFile }) {
    const entityTypes = useTypesDict(file);
    const { askUser, notify,ConfirmComponent } = useAsyncConfirm();

    const _exportFile = async (anonimize: boolean, type: "DOCX" | "PDF" | "SENDBACK") => {
        await file.save();
        await exportFile(file, entityTypes, anonimize, type,notify);
    }

    const handleAction = async () => {
        const confirmed = await askUser("Confirma a qualidade da anonimização?");
        
        if (confirmed) {
            await _exportFile(true, "SENDBACK");
        }
    };

    return (
        <>
            <Button 
                i="upload" 
                title="Submeter versão anonimizada" 
                text="Enviar para publicação" 
                className="btn-info btn m-1 p-1"
                onClick={handleAction}
                aria-expanded="false"
            />
            {ConfirmComponent}
        </>
    );
}



async function exportFile(file: UserFile, entityTypes: Record<string, EntityTypeI>, anonimized: boolean, type: "DOCX" | "PDF" | "SENDBACK",
   notify: (message: string) => Promise<boolean> 
) 
{   
    try{
        const offsets: SpecificOffsetRange[] = [];
        file.pool.entities.forEach(e => {
            e.offsets.forEach(o => {
                offsets.push({ ...o, ent: e });
            })
        });
        offsets.sort((a, b) => a.start - b.start);
        
        const html = renderBlock(file.doc, entityTypes, offsets, 
            anonimized ? AnonimizeStateState.ANONIMIZED : AnonimizeStateState.ORIGINAL, 
            0, 
            file.images, 
            { current: 0 },
            file.pool.nodeSizes
        );

        const winHtml = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>${file.name}</title></head><body>${html}</body></html>`;
        const cleanedHtml = winHtml;
        if (type === "SENDBACK") {
            await sendBackAnon(cleanedHtml, notify);
        }
    } catch (e) {
        if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'qa') {
            console.error("exportFile: falha ao exportar", e);
        }
        await notify("Não foi possível concluir a operação.");
    }
}

// function getUploadUrl(): string {
//     const isLocal = process.env.REACT_APP_CSM_UPLOAD_DOMAIN_LOCAL.includes("local");
//     const domain = process.env.REACT_APP_CSM_UPLOAD_DOMAIN_LOCAL;
//     const protocol = process.env.REACT_APP_PROTOCOL;

//     if (!isLocal) {
//         return `${protocol}//${domain}`;
//     }
//     return `${protocol}//${domain}`;
// }

function getUploadUrl(): string {
    const domain = process.env.REACT_APP_CSM_UPLOAD_DOMAIN_LOCAL;
    const protocol = process.env.REACT_APP_PROTOCOL;
    return `${protocol}//${domain}`;
}


async function sendBackAnon(retrievedText: string, notify: (msg: string) => Promise<boolean>){

    try {

        const url =  getUploadUrl();
        console.log(url);
        const htmlBlob = new Blob([retrievedText], { type: 'text/html; charset=utf-8' });
        if (window.opener && !window.opener.closed) {
            window.opener.postMessage({
                type: 'ANONYMIZATION_COMPLETE',
                payload: {
                    decisao_anonimizada : htmlBlob,
                    fileName: "decisao_anonimizada.html"
                 
                }
            }, url); 
            
            
            window.close();
        } else {
            await notify("Erro: aba original não encontrada.");
        }
    } catch (error) {
        if (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'qa') {
            console.error("sendBackAnon: erro ao enviar texto", error);
        }
        await notify("Erro ao enviar texto.");
    }
}
